import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'
import { APPS_LAUNCHERS_TYPES } from 'Data/common-constants'

export default function useListItemDataOnSubmit(props) {
  let phone_id = useDataValue({
    viewPath: props.viewPath,
    context: 'phone',
    path: 'phone._id',
  })
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ args, value, change }) {
    if (value.type === APPS_LAUNCHERS_TYPES.ACTION_EXTERNAL_MAPPING_REMOVE) {
      if (!window.confirm(`Are you sure?`)) return
    }

    let mutationResponse = await executeMutation({
      id: value.id,
      resource_id: phone_id,
      location_id,
    })
    if (mutationResponse.error) {
      return notify(notifyError(`There was a problem launching the app.`))
    }

    if (!mutationResponse.data.apps_launchers_resolve.ok) {
      return notify(
        notifyError(mutationResponse.data.apps_launchers_resolve.message)
      )
    }

    switch (value.type) {
      case APPS_LAUNCHERS_TYPES.URL_STATIC: {
        window.open(mutationResponse.data.apps_launchers_resolve.url)
        break
      }

      case APPS_LAUNCHERS_TYPES.URL_HTTP: {
        window.open(mutationResponse.data.apps_launchers_resolve.url)
        break
      }

      // TODO: implement
      case APPS_LAUNCHERS_TYPES.ACTION_QR: {
        break
      }

      // TODO: implement
      case APPS_LAUNCHERS_TYPES.ACTION_COMPONENT: {
        // setFlowTo(normalizePath(props.viewPath, '../../../../AppComponent'))
        break
      }

      case APPS_LAUNCHERS_TYPES.ACTION_HTTP: {
        break
      }

      // TODO: implement
      case APPS_LAUNCHERS_TYPES.ACTION_EXTERNAL_MAPPING_REMOVE: {
        break
      }

      default: {
        break
      }
    }

    if (mutationResponse.data.apps_launchers_resolve.message) {
      return notify(
        notifySuccess(mutationResponse.data.apps_launchers_resolve.message)
      )
    }
  }
}
